import { usePlatform } from '#Platform/composables/usePlatform'
import { parseStartParam } from '#Platform/startParam/parseStartParam'

/** Once per JS session — MiniAppShell remount must not re-route. */
let launchStartParamApplied = false

/**
 * After platform auth (shell mount), route once from launch startParam.
 * Garbage / unknown / invalid id → no navigation (catalog shell stays).
 * Missing product (404) is handled on PDP → catalog hub, never the gate.
 *
 * Deep links use Nuxt route names (no `#Order` / `#Products` imports) so
 * Platform stays free of those modules' DI.
 */
export function useStartParamLaunch() {
  const { payload } = usePlatform()

  function applyLaunchStartParam() {
    if (launchStartParamApplied) return
    launchStartParamApplied = true

    const intent = parseStartParam(payload.startParam)
    switch (intent.kind) {
      case 'order':
        void navigateTo({
          name: 'OrderDetail',
          params: { id: String(intent.orderId) },
        })
        return
      case 'product':
        void navigateTo({
          name: 'ProductsDetails',
          params: { id: String(intent.productId) },
        })
        return
      case 'none':
        return
      default: {
        const _exhaustive: never = intent
        void _exhaustive
      }
    }
  }

  return { applyLaunchStartParam }
}
